import { useParams } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import './BlogContent.css';
import { blogs } from '../../components/data/data/Blog/blogData';

const PLACEHOLDER_IMAGE = '/BLOG_PLACEHOLDER.png';

const BlogDetail = () => {
  const { slug } = useParams();
  const blog = blogs.find((b) => b.slug === slug);

  if (!blog) {
    return (
      <div className="bg-black text-white min-h-screen flex items-center justify-center">
        Blog not found
      </div>
    );
  }

  return (
    <section className="text-white w-full flex flex-col items-center">
      {/* Banner */}
      <div className="relative w-full mt-40 flex justify-center">
        <div className="relative h-[360px] md:h-[480px] w-full max-w-6xl px-4 overflow-hidden rounded-xl">
          {/* Image */}
          <img
            src={blog.image || PLACEHOLDER_IMAGE}
            alt={blog.title}
            className="absolute inset-0 w-full h-full object-cover"
          />

          {/* Blur + dark overlay */}
          <div className="absolute inset-0 bg-black/40 " />

          {/* Text */}
          <div className="relative z-10 h-full flex flex-col justify-end px-6 pb-10">
            <h1 className="text-2xl md:text-4xl font-telegraf font-semibold">
              {blog.title}
            </h1>

            <p className="mt-2 text-red-400 text-sm">{blog.date}</p>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="w-full flex justify-center mt-10 mb-10">
        <div className="w-full max-w-6xl px-4">
          {/* Tags */}
          <div className="flex flex-wrap gap-2 mb-10">
            {blog.tags.map((tag) => (
              <span
                key={tag}
                className="text-xs px-3 py-1 rounded-full bg-[#171616] text-[#9A9B9E] font-semibold"
              >
                {tag}
              </span>
            ))}
          </div>

          {/* Markdown */}
          <article className="blog-markdown">
            <ReactMarkdown
              remarkPlugins={[remarkGfm]}
              rehypePlugins={[rehypeRaw]}
            >
              {blog.content}
            </ReactMarkdown>
          </article>
        </div>
      </div>
    </section>
  );
};

export default BlogDetail;

// import { useParams } from 'react-router-dom';
// // import { blogs } from '../../components/data/data/blogData';
// import { blogs } from '../../components/data/data/Blog/blogData';
// import ReactMarkdown from 'react-markdown';
// import remarkGfm from 'remark-gfm';
// import BlogSpeechReader from '../../components/BlogSpeechReader';

// const PLACEHOLDER_IMAGE = '/BLOG_PLACEHOLDER.png';

// const markdownToText = (markdown) => {
//   return markdown
//     .replace(/!\[.*?\]\(.*?\)/g, '')
//     .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1')
//     .replace(/[#>*_`~-]/g, '')
//     .replace(/\n+/g, ' ')
//     .replace(/\s+/g, ' ')
//     .trim();
// };

// const BlogDetail = () => {
//   const { slug } = useParams();
//   const blog = blogs.find((b) => b.slug === slug);

//   if (!blog) {
//     return (
//       <div className="bg-black text-white min-h-screen flex items-center justify-center">
//         Blog not found
//       </div>
//     );
//   }

//   const speechText = markdownToText(blog.content); // 🔊

//   return (
//     <section className="bg-black text-white">
//       {/* Banner */}
//       <div className="relative h-[360px] md:h-[420px]">
//         <img
//           src={blog.image || PLACEHOLDER_IMAGE}
//           alt={blog.title}
//           className="w-full h-full object-cover"
//         />
//         <div className="absolute inset-0 bg-black/50" />
//         <div className="absolute bottom-10 w-full">
//           <div className="max-w-4xl mx-auto px-4">
//             <h1 className="text-4xl md:text-5xl font-telegraf font-semibold">
//               {blog.title}
//             </h1>
//             <p className="mt-2 text-red-400 text-sm">{blog.date}</p>
//           </div>
//         </div>
//       </div>

//       {/* Content */}
//       <div className="max-w-3xl mx-auto px-4 py-16">
//         {/* 🔊 Voice Reader */}
//         <BlogSpeechReader text={speechText} />

//         {/* Tags */}
//         <div className="flex flex-wrap gap-2 mb-10">
//           {blog.tags.map((tag) => (
//             <span
//               key={tag}
//               className="text-xs px-3 py-1 rounded-full bg-white/10 text-red-400"
//             >
//               {tag}
//             </span>
//           ))}
//         </div>

//         {/* Markdown Content */}
//         <article className="blog-markdown">
//           <ReactMarkdown remarkPlugins={[remarkGfm]}>
//             {blog.content}
//           </ReactMarkdown>
//         </article>
//       </div>
//     </section>
//   );
// };

// export default BlogDetail;
